import { posthog } from "../analytics/posthogClient.web"

export function usePostHog() {
  return posthog
}
